// extracted by mini-css-extract-plugin
export default {"labelItem":"LabelItem_labelItem__NuWls"};